const EndPointState = () => import('@/components/Dashboard/components/EndPointState.component.vue')
const UsageMetrics = () => import('@/components/Dashboard/components/usageMetric.component.vue')
const DetailedModelView = () => import('@/components/Dashboard/components/DetailedModelView.component.vue')
const ConversationLog = () => import('@/components/Dashboard/components/conversationLog.component.vue')
const ConversationMetrics = () => import('@/components/Dashboard/components/conversationMetric.component.vue')

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next()
    return
  }
  next()
}


export default [
  {
    path: 'EndPointState',
    name: 'EndPointState',
    meta:{
      title: 'dashboard',
      subtitle: 'EndPointState'
    },
    component: EndPointState,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'usageMetrics',
    name: 'usageMetrics',
    meta:{
      title: 'dashboard',
      subtitle: 'usageMetrics'
    },
    component: UsageMetrics,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'DetailedModelView',
    name: 'DetailedModelView',
    meta:{
      title: 'dashboard',
      subtitle: 'DetailedModelView'
    },
    component: DetailedModelView,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'conversationLog',
    name: 'conversationLog',
    meta:{
      title: 'dashboard',
      subtitle: 'conversationLog'
    },
    component: ConversationLog,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'conversationMetrics',
    name: 'conversationMetrics',
    meta:{
      title: 'dashboard',
      subtitle: 'conversationMetrics'
    },
    component: ConversationMetrics,
    beforeEnter: ifAuthenticated
  }
]


// WEBPACK FOOTER //
// ./src/router/dasboard.router.js